const minHeight = typeof window !== 'undefined' && window.innerHeight
const minWidth = typeof window !== 'undefined' && window.innerWidth

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100vh',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textField: {
    marginRight: theme.spacing.unit * 2,
    display: 'block',
    minWidth: minWidth / 2
  },
  block: {
    display: 'block'
  },
  modal: {
    minHeight: 600,
    minWidth: 600,
    maxWidth: minWidth / 1.5,
  },
  modalHeader: {
    textTransform: 'none!important',
    fontWeight:'600!important',
    fontSize: '1.2rem!important',
    
  },
  form: {
    height: 430,
    overflow: 'hidden'
  },
  button: {
    marginLeft: theme.spacing.unit * 2
  },
  flex: {
    flex: 1
  },
  scrollableList: {
    maxHeight: 140,
    overflowY: 'scroll'
  },
  summary: {
    padding: theme.spacing.unit
  },
  warning: {
    color: '#9F6000',
    backgroundColor: '#FEEFB3',
    padding: 10,
    textAlign: 'center'
  },
  submit: {
    marginLeft: theme.spacing.unit * 2,
    backgroundColor:  theme.palette.accent,
    color:'white',
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622'
    }
  },
  close: {
    padding:0,
    minWidth:40,
  },
  filePicker: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing.unit * 2,
  },
  fileInput: {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0,
  },
  filePickerButton: {
    margin: 0,
    border: `1px solid ${theme.palette.accent}`,
  },
  filePickerStatus: {
    marginLeft: theme.spacing.unit * 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  scrollableList: {
    maxHeight: 140,
    overflow: 'auto',
    '& li': {
      '&:nth-child(odd)': {
        backgroundColor: '#F7F7F7'
      },
    },
  },
})

export default styles
